import { Box, Checkbox, Icon, LinearProgress } from '@mui/material';
import { DataGridProProps, GridAlignment } from '@mui/x-data-grid-pro';
import React, { forwardRef, memo, useCallback, useMemo } from 'react';
import { EIcons } from '../../Icon';
import StyledDataGrid from '../DataGrid.styled';
import { RowActionButtons } from '../DataGrid.types';

interface DataGridViewProps extends DataGridProProps {
  header?: React.ReactElement<any, any>;
  rowActionButtons?: RowActionButtons[];
}

export const DataGridView: React.FC<DataGridViewProps> = memo(
  ({ className, header, columns, rowActionButtons, ...props }) => {
    const getRowSpacing = useCallback(() => {
      return {
        top: 12,
        bottom: 0
      };
    }, []);

    const updatedColumns = useMemo(() => {
      const newColumns = columns.map(column => ({
        flex: 1,
        headerAlign: 'left' as GridAlignment,
        align: 'left' as GridAlignment,
        ...column
      }));

      return newColumns;
    }, [columns]);

    return (
      <Box className={className} width="100%" height="100%" display="flex" flexDirection="column">
        {header && (
          <Box width="100%" display="flex" flexDirection="row" justifyContent="space-between">
            {header}
          </Box>
        )}

        <Box style={{ flexGrow: 1 }}>
          <StyledDataGrid
            disableColumnMenu
            getRowSpacing={getRowSpacing}
            autoHeight
            rowsPerPageOptions={[25, 50, 100]}
            components={{
              BaseCheckbox: forwardRef((props, ref) => <Checkbox color="default" inputRef={ref} {...props} />),
              MoreActionsIcon: props => <Icon name={EIcons.moreActions} {...props} />,
              LoadingOverlay: () => <LinearProgress style={{ zIndex: 1 }} />
            }}
            {...props}
            columns={updatedColumns}
            treeData={false}
          />
        </Box>
      </Box>
    );
  }
);
